"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const icons_1 = __importDefault(require("components/icons"));
const translate_1 = require("components/translate");
const badge_1 = require("components/v2/badge");
const constants_1 = require("configs/routes/constants");
const useModal_1 = require("hooks/useModal");
const useShellContext_1 = require("hooks/useShellContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const contentImport_1 = require("modules/app/services/datahub/contentImport");
const featureToggle_1 = require("modules/featureToggle");
const ReviewOverlay_1 = __importDefault(require("modules/reviews/components/ReviewOverlay"));
const ReviewService_1 = __importDefault(require("modules/reviews/ReviewService"));
const types_1 = require("modules/reviews/types");
const ui_1 = require("modules/ui");
const AIContentModal_1 = require("./AIContentModal");
const BulkUploadButton_1 = require("./BulkUploadButton");
const contentImportCallToAction_1 = __importDefault(require("./contentImportCallToAction"));
const CreateButton_1 = __importDefault(require("./CreateButton"));
const CreateDropdown_1 = __importDefault(require("./CreateDropdown"));
const mapStateToProps = ({ FeatureToggleStore }) => ({
    isContentStructureAIFeatureEnabled: FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.ContentStructureAI),
    isImportContentFeatureEnabled: FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.ContentImport)
});
const HeaderActions = ({ t, isContentStructureAIFeatureEnabled = false, isImportContentFeatureEnabled = false, onCreateModule }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const aiContentModal = (0, useModal_1.useModal)();
    const reviewModal = (0, useModal_1.useModal)();
    const contentImportCallToActionModal = (0, useModal_1.useModal)();
    const { isMembership } = (0, useShellContext_1.useShellContext)();
    const handleStructureSuggestions = () => {
        aiContentModal.handleOpen();
    };
    const handleModalClose = (showReview = false) => {
        aiContentModal.handleClose();
        if (showReview) {
            reviewModal.handleOpen();
        }
    };
    const handleReviewSubmit = (review) => {
        reviewModal.handleClose();
        ui_1.UiService.setAlertSuccess('review_success');
        ReviewService_1.default.save(types_1.ReviewSubject.AIContentStructure, review);
    };
    const handleContentImport = () => {
        if (isMembership) {
            history.push(constants_1.ROUTES.CONTENT.IMPORT);
        }
        else {
            contentImport_1.DatahubContentImportService.sendShowCallToActionEvent();
            contentImportCallToActionModal.handleOpen();
        }
    };
    const renderCreateButton = () => {
        if (isContentStructureAIFeatureEnabled) {
            return ((0, jsx_runtime_1.jsx)(CreateDropdown_1.default, { onCreateModuleClick: onCreateModule, onStructureSuggestionsClick: handleStructureSuggestions }));
        }
        return ((0, jsx_runtime_1.jsxs)(CreateButton_1.default, { onClick: onCreateModule, children: [(0, jsx_runtime_1.jsx)(icons_1.default, { prefix: "fal", iconName: "plus", className: "_mr-2" }), t('content_list.add_module', { checkOnlineEvent: true })] }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _flex-md-row _justify-content-md-end _w-full", children: [(0, jsx_runtime_1.jsx)(BulkUploadButton_1.BulkUploadButton, { className: "_mr-0 _mr-md-4 _mb-3 _mb-md-0 _d-flex _justify-content-center _align-items-center" }), isImportContentFeatureEnabled && ((0, jsx_runtime_1.jsxs)(button_1.default, { variation: "secondary", className: "_mr-0 _mr-md-4 _mb-3 _mb-md-0", onClick: handleContentImport, children: [t('import_content.title'), (0, jsx_runtime_1.jsx)(badge_1.Badge, { className: "_font-weight-bold _ml-3", children: t('general.new') })] })), renderCreateButton()] }), aiContentModal.isModalOpen && ((0, jsx_runtime_1.jsx)(AIContentModal_1.AIContentModal, { onCloseModal: handleModalClose })), reviewModal.isModalOpen && ((0, jsx_runtime_1.jsx)(ReviewOverlay_1.default, { title: t('reviews.questions.ai_content_structure'), onClose: reviewModal.handleClose, onSubmit: handleReviewSubmit })), contentImportCallToActionModal.isModalOpen && ((0, jsx_runtime_1.jsx)(contentImportCallToAction_1.default, { onClose: contentImportCallToActionModal.handleClose }))] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(mapStateToProps))(HeaderActions);
